import { BaseModel } from '../base.model';
import { JsonProperty } from '../json-map.util';
import { ProblemRecentPerformanceModel } from '../problem-progress/problem-recent-performance.model';

class ExerciseRecentPerformanceModel extends BaseModel {

  id: number = undefined;
  exerciseId: number = undefined;
  isComplete: boolean = undefined;
  playedPersistence: number = undefined;
  openAnswer: string = undefined;
  exerciseTitle: string = undefined;
  lessonTitle: string = undefined;

  @JsonProperty({ clazz: ProblemRecentPerformanceModel })
  problemProgress: ProblemRecentPerformanceModel[] = undefined;
}

export { ExerciseRecentPerformanceModel };
